/**
 * @file Scroll related utilities.
 */

/**
 * Get how much of the page is currently scrolled in percentage.
 *
 * @returns {number} - Scroll percentage.
 */
const getPercentWindowScrolled = () => {
  const h = document.documentElement;
  const b = document.body;
  const st = 'scrollTop';
  const sh = 'scrollHeight';
  return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
};

const hasVerticalScroll = () => {
  return document.body.scrollHeight > document.body.clientHeight;
};

/**
 * How much of the target element has been scrolled.
 *
 * @param {HTMLElement} target The element to look for current scroll percentage.
 * @returns {number} - Scroll percentage of target.
 */
const getPercentTargetScrolled = target => {
  const { clientHeight, scrollTop, scrollHeight } = target;

  return (scrollTop / (scrollHeight - clientHeight)) * 100;
};

/**
 * Checks if the provided HTML element has vertical scrollbars.
 *
 * @param {HTMLElement} element The HTML element to check.
 * @param {number} offset Pixel offset.
 * @returns {boolean} Whether the HTML element has vertical scrollbars or not.
 */
const elementHasVerticalScroll = (element, offset = 0) => {
  return element.scrollHeight > element.clientHeight + offset;
};

/**
 * Checks if the provided HTML has bottomed in its scroll
 * (or close to bottoming by providing an offset).
 *
 * @param {HTMLElement} element The HTML element to check.
 * @param {number} offset Pixel offset threshold from bottom.
 * @returns {boolean} Whether the HTML element has bottomed or is close to bottoming.
 */
const elementScrollHasReachedBottom = (element, offset = 0) => {
  return (
    element.scrollTop >= element.scrollHeight - element.clientHeight - offset
  );
};

export {
  getPercentWindowScrolled,
  hasVerticalScroll,
  getPercentTargetScrolled,
  elementHasVerticalScroll,
  elementScrollHasReachedBottom,
};
